import React, { Component } from "react";
import { Map, GoogleApiWrapper, InfoWindow, Marker } from "google-maps-react";
import "./style.css"
const mapStyles = {
  width: "60%",
  height: "70%",
  marginLeft: "200px"
};

export class MapContainer extends Component {
  state = {
    showingInfoWindow: false, //Hides or the shows the infoWindow
    activeMarker: {}, //Shows the active marker upon click
    selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
  };
  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });

  onClose = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };
  render() {
    return (
      <div className="map-section">
      <div>
        <Map
          google={this.props.google}
          zoom={14}
          style={mapStyles}
          initialCenter={{ lat: 32.072578, lng: 34.784779 }}
        >
          <Marker onClick={this.onMarkerClick} name={"Lawyerz משרדי"} />
          <InfoWindow
            marker={this.state.activeMarker}
            visible={this.state.showingInfoWindow}
            onClose={this.onClose}
          >
            <div>
              <h4>{this.state.selectedPlace.name}</h4>
            </div>
          </InfoWindow>
        </Map>
        </div>

        <div className="contact-info">
        <p>מספר טל': 054-1234567 <i class="fa fa-phone"></i></p>
        <p>דף פייסבוק <i class="fa fa-facebook"/></p>
        <p>דף לינקדאין <i class="fa fa-linkedin"/></p>
        <p>כתובת <i class="fa fa-map-marker"></i></p>
        </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAFQrVzQB6YcnTef2TJqsV3Tb35folqi5Q",
})(MapContainer);

// export default function GoogleApiWrapper({
//   apiKey: 'AIzaSyAFQrVzQB6YcnTef2TJqsV3Tb35folqi5Q'
// })(MapContainer);
